export default {
  active_orders: {
    title: 'Active orders',
  },
  order_history: {
    title: 'Order History',
  },
  menu: {
    title: 'Menu',
  },
  printer_settings: {
    title: 'Printer settings',
  },
  order_control: {
    title: 'Order Control',
  },
  busy_mode: {
    title_zero: 'Busy mode',
    title_other: 'Busy mode (+{{time}} min)',
  },
  volume: {
    title: 'Volume',
  },
  switch_language: {
    title: 'Switch language ({{language}})',
  },
  logout: {
    title: 'Logout',
    description: 'Are you sure you want to logout?',
    buttons: {
      confirm: 'Yes',
      cancel: 'Cancel',
    },
  },
  test_restaurant: {
    label: 'Test',
    tooltip: 'Test restaurant: its orders are tests and it is never billed.',
  },
};
